import { c as _c } from "react/compiler-runtime";
import { CityType, CityTypeInitialValue } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/types";
import { TourErrorsType } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const useValidation = t0 => {
  const $ = _c(13);
  const {
    originItem,
    destinationItem
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      originError: "",
      destinationError: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [errors, setErorrs] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setErorrs(_temp);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== originItem) {
    t3 = [originItem];
    $[2] = originItem;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setErorrs(_temp2);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== destinationItem) {
    t5 = [destinationItem];
    $[5] = destinationItem;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== destinationItem || $[8] !== originItem) {
    t6 = () => {
      let hasError = false;
      if (!destinationItem) {
        setErorrs(_temp3);
        hasError = true;
      }
      if (!originItem) {
        setErorrs(_temp4);
        hasError = true;
      }
      if (hasError) {
        return false;
      }
      return true;
    };
    $[7] = destinationItem;
    $[8] = originItem;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const submitValidationCheck = t6;
  let t7;
  if ($[10] !== errors || $[11] !== submitValidationCheck) {
    t7 = {
      errors,
      submitValidationCheck
    };
    $[10] = errors;
    $[11] = submitValidationCheck;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};

//TODO: Please review
export const useSubmit = (destinationItem, originItem, cityToInitialValue, cityFromInitialValue, isHomePage, submitValidationCheck) => {
  const $ = _c(15);
  const router = useRouter();
  const {
    pathname
  } = router;
  const searchActionTitle = isHomePage ? "\u062C\u0633\u062A\u062C\u0648" : "\u0628\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u062C\u0633\u062A\u062C\u0648";
  let t0;
  if ($[0] !== cityFromInitialValue?.slug || $[1] !== cityFromInitialValue?.type || $[2] !== cityToInitialValue?.title || $[3] !== cityToInitialValue?.type || $[4] !== destinationItem?.slug || $[5] !== destinationItem?.type || $[6] !== originItem?.slug || $[7] !== originItem?.type || $[8] !== pathname || $[9] !== router || $[10] !== submitValidationCheck) {
    t0 = () => {
      if (submitValidationCheck()) {
        const parameters = {
          type: destinationItem?.type as string || cityToInitialValue?.type as string,
          dest: destinationItem?.slug as string || cityToInitialValue?.title as string,
          origin_type: originItem?.type as string || cityFromInitialValue?.type as string,
          origin_slug: originItem?.slug as string || cityFromInitialValue?.slug as string,
          source: "searchBox",
          referrer: "",
          search_source: "search_results_page"
        };
        pathname === "/tour" ? window.location.href = `/tour/group?${new URLSearchParams(Object.entries(parameters)).toString()}` : router.replace({
          pathname,
          query: omit(parameters, "OPEN_SEARCH")
        }, undefined);
      }
    };
    $[0] = cityFromInitialValue?.slug;
    $[1] = cityFromInitialValue?.type;
    $[2] = cityToInitialValue?.title;
    $[3] = cityToInitialValue?.type;
    $[4] = destinationItem?.slug;
    $[5] = destinationItem?.type;
    $[6] = originItem?.slug;
    $[7] = originItem?.type;
    $[8] = pathname;
    $[9] = router;
    $[10] = submitValidationCheck;
    $[11] = t0;
  } else {
    t0 = $[11];
  }
  const onSubmitClick = t0;
  let t1;
  if ($[12] !== onSubmitClick || $[13] !== searchActionTitle) {
    t1 = {
      onSubmitClick,
      submitText: searchActionTitle
    };
    $[12] = onSubmitClick;
    $[13] = searchActionTitle;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
};
function _temp(previousError) {
  return {
    ...previousError,
    originError: ""
  };
}
function _temp2(previousError_0) {
  return {
    ...previousError_0,
    destinationError: ""
  };
}
function _temp3(previousError_1) {
  return {
    ...previousError_1,
    destinationError: "\u0644\u0637\u0641\u0627 \u0645\u0642\u0635\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F"
  };
}
function _temp4(previousError_2) {
  return {
    ...previousError_2,
    destinationError: "\u0644\u0637\u0641\u0627 \u0645\u0628\u062F\u0623 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F"
  };
}